import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppConfig, SystemHeader } from '../../../service/DTOs';
import * as TF from '../../../service/tradeflow';
import * as DTO from '../../../service/DTOs';
import * as API from '../../../service/apisvc';
import * as RB from 'react-bootstrap';
import * as Actions from '../../../service/Actions';
import * as Dispatch from '../../../service/Dispatcher';



type EntityRecordProps = Actions.OrderState & { xsrfToken?: string } & { record: DTO.EntityDto } & { entitySelected: any } & { entityRemove: any };

export const initialstate_entityrecord: Actions.OrderState = {
    processing: false,
    haserrors: false,
    modified: false,
    selected: false
}



export class EntityRecord extends React.Component<EntityRecordProps, Actions.OrderState> {
    constructor(props: EntityRecordProps) {
        super(props);
        this.state = {
            ...initialstate_entityrecord, ...{ processing: props.processing, haserrors: props.haserrors, modified: props.modified }
        };
    }

    componentWillReceiveProps(nextProps: EntityRecordProps) {
        this.setState(nextProps);
    }

    _onSelectSec = (locatorId: string, record: DTO.EntityDto) => {
        return this.props.entitySelected(locatorId, record);
    }

    _onRemoveSec = (locatorId: string, record: DTO.EntityDto) => {
        return this.props.entityRemove(locatorId, record);
    }

    public render() {
        let bg_color = this.state.modified ? '#9be8d7' : (this.state.processing ? '#7c8887' : (this.state.selected ? undefined : 'white'));
        //let row_border = this.state.selected ? { borderStyle: 'solid', borderWidth: '2.5px' } : { borderStyle: 'none'};

        //let crsr = this.props.record.manipulation.perms.includes(DTO.MANIPULATION_PERM_CONTEXT) ? { cursor: 'pointer' } : {};
        let crsr = { cursor: 'pointer' };

        let trStyle: React.CSSProperties  = {
            //...{ backgroundColor: bg_color }, ...row_border, ...crsr
            ...{ textAlign: 'right' }, ...{ backgroundColor: bg_color }, ...crsr
        };

        var trClass: string = (this.state.selected ? 'rowselected' : '');
        //REUTER:{this.props.record.reutercode}{', '}Bloomberg:{this.props.record.bloombergcode}

        return <tr key={this.props.record.id} className={trClass} style={trStyle} onClick={this._onSelectSec.bind(this, '' + this.props.record.id, this.props.record)}>
            <td style={{ textAlign: 'right', width: '30%' }} >
                <RB.ButtonGroup bsSize="xsmall" className={'record-man-tool'}>
                    <RB.Button title='Исключить' disabled={this.state.processing} onClick={this._onRemoveSec.bind(this, '' + this.props.record.id, this.props.record)}><RB.Glyphicon glyph="minus" /></RB.Button>
                </RB.ButtonGroup>
                {this.props.record.reutercode}
            </td>
            <td style={{ textAlign: 'right', width: '20%' }}>{this.props.record.shortname}</td>
            <td style={{ textAlign: 'right', width: '50%' }}>{this.props.record.fullname}</td>
        </tr>;
    }

}
